import React from 'react';
import { Component } from '@poa/core';
import { observable, Observer } from '@poa/state';
import Spinner from 'react-spinkit';
import { getValue } from '../../data-table/data-table-helpers';



class AccountIncome extends React.Component {
    store; // injected by Poa

    localState = observable({
        isLoading: false,
        accountIncome: {
            accountLevel: 0,
            data: {
                thead: [],
                tbody: [],
                tfoot: []
            }
        },
        hasError: false,
    });

    async componentDidMount() {
        try {
            this.localState.isLoading = true;
            let response = await this.env.http.get(
                `/account_income/${this.store.accounts.originalModel.id}/`
            );
            this.localState.accountIncome = response.data;
        } catch (error) {
            this.localState.hasError = true;
            console.error("AccountIncome load: ", error);
        } finally {
            this.localState.isLoading = false;
        }
    }

    render() {

        return (

            <Observer>
                {() => (
                    this.localState.isLoading ? (
                        <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
                            <Spinner name="folding-cube" fadeIn="none" />
                        </div>) :
                    <div className='general_info__content'>
                        <div className="account-income">
                            <div className="title-name-row">
                                <div className='main-title-name'>
                                    УРОВЕНЬ АНКЕТЫ: {this.localState.accountIncome.accountLevel}
                                </div>
                            </div>
                            <div className="account-income__body">
                                <table className="account-income__table">
                                    <thead>
                                        <tr>
                                            <th />
                                            {this.localState.accountIncome.data.thead.map((head, idx) => (
                                                <th key={idx}>
                                                    <b>{head}</b>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.localState.accountIncome.data.tbody.map(tbody => (
                                            <tr key={tbody.id}>
                                                <td>
                                                    <b>{tbody.title}</b>
                                                </td>
                                                {tbody.data.map(item => (
                                                    <td key={item.id}>{getValue(parseFloat(item.value))}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>ИТОГО</td>
                                            {this.localState.accountIncome.data.tfoot.map((tfoot, idx) => (
                                                <th key={idx}>{getValue(parseFloat(tfoot))}</th>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </Observer>
        );
    }
}

export default Component({ namespaces: ['account-income'] })(AccountIncome);